import React, { useState } from 'react';
import { withRouter, Link, useHistory } from 'react-router-dom';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import axios from 'axios';
import { Tab, Tabs, TabPanel, TabList } from 'react-tabs';
import { Typography } from '@material-ui/core';
import 'react-tabs/style/react-tabs.css';
import _get from 'lodash/get';
import { Alert, Form } from 'react-bootstrap';
import { useLogin } from './useLogin';
import { login } from './LoginActions.js';
import { SET_CURRENT_USER } from './LoginTypes.js';
import layerSlayers from '../../assets/LayerSlayersLogo.png';
import Header from '../header/Header';
import { Container, Wrapper, HomeButtons } from '../../styles/HomeStyles';
import { FormWrapper, Label } from '../../styles/LoginStyles';
import { config } from '../../config';
import { Toast } from '../student/Home';

const useStyles = makeStyles(theme => ({
  tabTextColor: {
    backgroundColor: '#4287cc'
  },
  tabColor: {
    backgroundColor: '#000'
  },
  tabs: {
    width: 100,
    textAlign: 'center',
    color: '#fff'
  }
}));

export default function Login() {
  const history = useHistory();
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState('');
  const [errorMsg, setError] = useState('');
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertFailure, setAlertFailure] = useState(false);

  const { setCurrentUser, userInfo } = useLogin();

  const onLogin = () => {
    const userData = {
      email,
      password
    };
    // login(userData, "/dashboard");

    const mailregex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email === '' || password === '') {
      setStatus('Email or Password cannot be blank');
      setAlertFailure(true);
    } else if (!email.match(mailregex)) {
      setStatus('Email has an invalid format');
      setAlertFailure(true);
    } else {
      axios
        .post(`${config.API_URL}user/auth/login/`, userData)
        .then(response => {
          setStatus('success');
          localStorage.setItem('userId', _get(response, 'data.data.userid', 0));
          localStorage.setItem(
            'user',
            JSON.stringify(_get(response, 'data.data', []))
          );
          localStorage.setItem(
            'loginToken',
            _get(response, 'data.data.token.value', 0)
          );
          if (_get(response, 'data.data.userType.usertypeid', []) === 1) {
            history.push('/super-admin');
          } else if (
            _get(response, 'data.data.userType.usertypeid', []) === 2
          ) {
            history.push('/admin');
          } else if (
            _get(response, 'data.data.userType.usertypeid', []) === 3
          ) {
            history.push('/instructor');
          } else if (
            _get(response, 'data.data.userType.usertypeid', []) === 4
          ) {
            history.push('/student');
          }
        })
        .catch(error => {
          console.log(error, 'errr');
          setStatus('Invalid credentials! Please try again');
          setAlertFailure(true);
        });
    }
  };

  const errorAlert = (
    <Alert variant="danger">
      <Alert.Heading>Error</Alert.Heading>
      {errorMsg}
    </Alert>
  );

  const successAlert = (
    <Alert variant="success">
      <Alert.Heading>Login Successful</Alert.Heading>
      {/* <p>
          We send you an email with activation link. Please check your email.
        </p> */}
      <p>You have successfully logged in!</p>
    </Alert>
  );
  let alert = '';
  if (status === 'error') {
    alert = errorAlert;
  } else if (status === 'success') {
    alert = successAlert;
  }

  const handleClose = (event, reasons) => {
    if (reasons === 'clickaway') {
      return;
    }
    setAlertFailure(false);
    setAlertSuccess(false);
  };

  return (
    <Container>
      <Header isHome={true} center={true} />
      <Snackbar
        open={alertFailure}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Toast onClose={handleClose} severity="error">
          {status}
        </Toast>
      </Snackbar>
      <Snackbar
        open={alertSuccess}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Toast onClose={handleClose} severity="success">
          {status}
        </Toast>
      </Snackbar>
      <Wrapper>
        <FormWrapper>
          {alert}
          <Form>
            <Form.Group controlId="emailId">
              <Label>Email</Label>
              <Form.Control
                type="text"
                name="email"
                placeholder="Enter email"
                value={email}
                onKeyPress={event => {
                  if (event.key === 'Enter') {
                    onLogin();
                  }
                }}
                onChange={e => setEmail(e.currentTarget.value)}
              />
            </Form.Group>

            <Form.Group controlId="passwordId">
              <Label>Password</Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="Enter password"
                value={password}
                onKeyPress={event => {
                  if (event.key === 'Enter') {
                    onLogin();
                  }
                }}
                onChange={e => setPassword(e.currentTarget.value)}
              />
            </Form.Group>
          </Form>
        </FormWrapper>
        <center>
          <HomeButtons color="primary" onClick={onLogin}>
            Login
          </HomeButtons>
        </center>
        <Label>
          Don't have account? <Link to="/signup">Signup</Link>
        </Label>
        <Label>
          Forgot password? <Link to="/send_reset_password">Reset Password</Link>
        </Label>
      </Wrapper>
    </Container>
  );
}
